import { signInWithRedirect } from 'aws-amplify/auth'

interface GoogleLoginProps {
  hasAuthError?: boolean
}

export const GoogleLogin: React.FC<GoogleLoginProps> = ({ hasAuthError }) => {
  const onGoogleLogin = async () => {
    try {
      await signInWithRedirect({ provider: 'Google' })
    } catch (err) {
      console.error('Google sign-in failed:', err)
    }
  }

  const onUseOtherAccount = () => {
    // Open Google's Add Account page so the user can sign into a different Google account.
    // After adding it, Google will show the account picker on next sign-in attempt.
    window.open('https://accounts.google.com/AddSession', '_blank')
  }

  return (
    <>
      <button className="google-signin-btn" onClick={onGoogleLogin} type="button">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" width="20" height="20" />
        <span>Sign in with Google</span>
      </button>
      {hasAuthError && (
        <button className="google-other-account-btn" onClick={onUseOtherAccount} type="button">
          Use a different Google account
        </button>
      )}
    </>
  )
}
